window.HELP_IMPROVE_VIDEOJS = false;

import videojs from 'video.js';
import 'videojs-contrib-hls';

window.HELP_IMPROVE_VIDEOJS = false;

document.addEventListener('DOMContentLoaded', (event) => {
    [...document.getElementsByTagName('video')].forEach(function (element) {
        element.classList.add('video-js');
        element.classList.add('vjs-default-skin');
        element.classList.add('vjs-big-play-centered');

        const videoViewUrl = element.getAttribute('data-video-view-url');

        var player = videojs(element, {
            fluid: false,
            controls: true,
            preload: 'auto',
            textTrackSettings: false,
            html5: {
                nativeTextTracks: false
            },
        });

        if (!videoViewUrl) {
            return;
        }

        let secondsWatched = 0;
        let timestamps = [];

        player.on('timeupdate', function (event) {
            const currentTime = +player.currentTime().toFixed(0);

            if (timestamps.indexOf(currentTime) < 0) {
                timestamps.push(currentTime);
            }

            if (secondsWatched == timestamps.length) {
                return;
            }

            secondsWatched = timestamps.length

            if (secondsWatched < 2 || secondsWatched % 5 === 0) {
                axios.post(videoViewUrl, { seconds_watched: secondsWatched })
            }
        });
    });
})
